var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.268555,
    y: 0.301453,
    width: 64,
    height: 64,
    rx: 18.6182,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2154 27.9587V22.5269C44.2154 21.9508 43.9866 21.3983 43.5792 20.991C43.1719 20.5836 42.6194 20.3548 42.0433 20.3548H36.251",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.942 20.3548H18.1497C17.5736 20.3548 17.0211 20.5836 16.6137 20.991C16.2064 21.3983 15.9775 21.9508 15.9775 22.5269V46.4202C15.9775 46.9963 16.2064 47.5488 16.6137 47.9562C17.0211 48.3635 17.5736 48.5924 18.1497 48.5924H30.0934",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7742 21.7841C35.702 22.0001 35.5638 22.188 35.3791 22.3213C35.1943 22.4546 34.9724 22.5265 34.7446 22.5269H25.4494C25.2213 22.5268 24.9991 22.4551 24.8141 22.3218C24.6291 22.1884 24.4906 22.0003 24.4184 21.7841L22.9703 17.4398C22.9155 17.2765 22.9005 17.1025 22.9264 16.9323C22.9522 16.762 23.0183 16.6003 23.1191 16.4606C23.2198 16.321 23.3524 16.2073 23.5058 16.129C23.6592 16.0507 23.8291 16.0101 24.0013 16.0106H36.1927C36.3648 16.0104 36.5345 16.0511 36.6877 16.1295C36.841 16.2079 36.9733 16.3216 37.0739 16.4612C37.1745 16.6009 37.2405 16.7624 37.2662 16.9326C37.292 17.1028 37.277 17.2766 37.2223 17.4398L35.7742 21.7841Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8386 44.2481H21.4054C21.1174 44.2481 20.8411 44.1337 20.6374 43.93C20.4338 43.7263 20.3193 43.4501 20.3193 43.1621V24.699",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8711 24.699V26.8712",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8682 48.5924C44.6667 48.5924 48.5567 44.7024 48.5567 39.9039C48.5567 35.1054 44.6667 31.2154 39.8682 31.2154C35.0697 31.2154 31.1797 35.1054 31.1797 39.9039C31.1797 44.7024 35.0697 48.5924 39.8682 48.5924Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7402 37.3712L39.5335 42.981C39.44 43.1054 39.3208 43.2083 39.1841 43.2827C39.0474 43.3571 38.8963 43.4013 38.741 43.4123C38.5858 43.4232 38.43 43.4008 38.2842 43.3464C38.1383 43.2919 38.0059 43.2069 37.8958 43.0969L35.7236 40.9247",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.666 29.0433H31.1824",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.666 35.5597H26.8381",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIcon);
export default __webpack_public_path__ + "static/media/reminder-icon.74efa477b3dd4422f51e11a34dbcea9a.svg";
export { ForwardRef as ReactComponent };